module.exports = __webpack_public_path__ + "img/item1-2.29bbf6f0.jpg";